export enum ServerStatus {
    UNKNOWN = 'UNKNOWN',
    REFRESHING = 'REFRESHING',
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
}